/* eslint-disable @typescript-eslint/no-explicit-any */ import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ManagedRuntime } from "effect";
import { useRuntime } from "../hooks/useRuntimeFn";
/*
This HOC creates a runtime for the context and provides it to the component.
It allows any downstream components to access the runtime using the context.
*/ // TODO: think about assigning a method to the function, to obtain the provided react context objects in the hoc as an array, for testing purposes. We can separate the hoc from the pipe function and export the method as a named export.
export const WithRuntime = (Context, getSource)=>(Component)=>{
        //
        const Wrapped = (props)=>{
            const { layer } = Context;
            const targetRuntime = useRuntimeFactory(layer);
            const extraProps = {};
            if (getSource) {
                getSource({
                    //* getSource never changes over the lifetime of the component, so it is safe to break the rules of hooks here.
                    from: (context, linkEffect)=>{
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        const runtime = React.useContext(context);
                        if (runtime === undefined) throw new Error("No runtime found.");
                        const effect = linkEffect(runtime);
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useRuntime(targetRuntime, effect, [
                            targetRuntime
                        ]);
                    },
                    propsOf: (context, injectEffect)=>{
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        const runtime = React.useContext(context);
                        if (runtime === undefined) throw new Error("No runtime found.");
                        const result = injectEffect(runtime);
                        Object.assign(extraProps, result);
                        return result;
                    },
                    to: (context, attachEffect)=>{
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        const runtime = React.useContext(context);
                        if (runtime === undefined) throw new Error("No runtime found.");
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useRuntime(context, attachEffect(targetRuntime), [
                            runtime
                        ]);
                    }
                });
            }
            return /*#__PURE__*/ _jsx(Context.Provider, {
                value: targetRuntime,
                children: /*#__PURE__*/ _jsx(Component, {
                    ...props,
                    ...extraProps
                })
            });
        };
        Wrapped.displayName = `WithRuntime`;
        return Wrapped;
    };
/*
This hook creates a runtime and disposes it when the component is unmounted.
It is used by withRuntime to create a runtime for the context. 
This is both compatible with strict mode and fast refresh. 🚀
*/ const useRuntimeFactory = (layer)=>{
    const disposed = React.useRef(false);
    const [runtime, setRuntime] = React.useState(()=>ManagedRuntime.make(layer));
    React.useEffect(()=>{
        let current = runtime;
        if (disposed.current) {
            current = ManagedRuntime.make(layer);
            setRuntime(()=>current);
            disposed.current = false;
        }
        return ()=>{
            void current.dispose();
            disposed.current = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        layer
    ]);
    return runtime;
};
